(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-registration"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-warranty-center]').forEach((section) => {
    const params = new URLSearchParams(window.location.search);
    const findParam = (keys) => {
      for (const key of keys) {
        const value = params.get(key);
        if (value) return value.trim();
      }
      return '';
    };

    let detectedSerialNumber = false;
    const map = [
      {
        keys: ['serial', 'sn', 'serial_number', 'product_sn'],
        selector: '[data-warranty-serial]',
        detected: 'serial'
      },
      {
        keys: ['model', 'sku', 'product_model'],
        selector: '[data-warranty-model]'
      },
      {
        keys: ['order', 'order_number', 'orderno'],
        selector: '[data-warranty-order]'
      }
    ];

    map.forEach((item) => {
      const value = findParam(item.keys);
      const input = section.querySelector(item.selector);
      if (value && input && !input.value) {
        input.value = value;
        if (item.detected === 'serial') detectedSerialNumber = true;
      }
    });

    const serialInput = section.querySelector('[data-warranty-serial]');
    const serialGuide = section.querySelector('.wc__activation-guide');
    const serialModule = section.querySelector('[data-warranty-serial-module]');
    const serialStatus = section.querySelector('[data-warranty-serial-status]');
    const serialBadge = section.querySelector('[data-warranty-serial-badge]');
    const serialSource = section.querySelector('[data-warranty-serial-source]');
    const serialJump = section.querySelector('[data-warranty-serial-jump]');
    const updateSerialState = () => {
      const hasSerial = serialInput && serialInput.value.trim().length > 0;
      if (serialGuide) serialGuide.classList.toggle('is-detected', hasSerial);
      if (serialModule) serialModule.classList.toggle('is-detected', hasSerial);
      if (serialStatus) {
        serialStatus.textContent = hasSerial
          ? (detectedSerialNumber ? 'QR serial number detected' : 'Serial number entered')
          : 'Waiting for serial number';
      }
      if (serialBadge) {
        serialBadge.textContent = hasSerial ? 'Detected' : 'From QR';
        serialBadge.classList.toggle('is-detected', hasSerial);
      }
      if (serialSource) {
        serialSource.value = hasSerial
          ? (detectedSerialNumber ? 'QR / URL serial number detected' : 'Manual serial number entered')
          : 'Serial number missing';
      }
    };

    if (serialInput) {
      serialInput.addEventListener('input', () => {
        detectedSerialNumber = false;
        updateSerialState();
      });
      updateSerialState();
    }

    if (serialJump && serialInput) {
      serialJump.addEventListener('click', () => {
        window.setTimeout(() => serialInput.focus(), 0);
      });
    }

    const success = section.querySelector('.wc__success');
    if (success) {
      success.focus();
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
